export default "__VITE_ASSET__e475ebef__"